import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { StepsModule } from 'primeng/steps';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormViewer, FormSectionPageComponent,CustomTitle, FormCreatorService, Form } from 'lib-base';

@Component({
  selector: 'app-form-viewer',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, FormSectionPageComponent,
    ButtonModule, CardModule, StepsModule, TranslateModule, CustomTitle
  ],
  providers: [FormCreatorService],
  template: `
  <div *ngIf="this.fc.Pages.length > 1" class="mb-2">
    <p-steps [model]="pageItems" [activeIndex]="fc.activeIndex"></p-steps>
  </div>

  <div class="form-panel-preview">
    <CustomTitle *ngIf="fc.Form.title" [title]="fc.Form.title" styleClass="font-principal font-20 title-blue border-round
                  ml-1 font-medium px-5 py-3 w-full bg-gray-200" />
    <div class="content formgrid p-fluid">
      <form #form="ngForm" [formGroup]="fc.FormGroup">
        <ng-container *ngIf="fc.activePage">
          <app-form-section-page [page]="fc.activePage" [pageIndex]="fc.activeIndex"
            [formGroup]="fc.getPageFormGroup(fc.activePage.name)" [isDesigner]="isDesigner">
          </app-form-section-page>
        </ng-container>
      </form>
    </div>
    <div class="footer">
      <div>
        <p-button *ngIf="!isFirstPage" [label]="'form.button.atras' | translate" (onClick)="prevPage()"
          icon="pi pi-angle-left"></p-button>
      </div>
      <div>
        <p-button *ngIf="!isLastPage" [label]="'form.button.siguiente' | translate" (onClick)="nextPage()"
          icon="pi pi-angle-right" iconPos="right"></p-button>
        <p-button *ngIf="isLastPage && fc.enableSubmit" [label]="'form.button.submit' | translate" (onClick)="submit()"
          icon="pi pi-angle-right" iconPos="right" styleClass="p-button-success"></p-button>
      </div>
    </div>
  </div>
  `,
  styleUrl: './form-viewer.component.scss'
})
export class FormViewerComponent extends BaseFormViewer{

  constructor(public override fc: FormCreatorService) {
    super(fc);
    const options = {
      isDesigner: true,
      enableSubmit: false
    }
    this.fc.setOptions(options);
  }

  public loadForm(response: Form){
    this.fc.loadForm(response);
  }

  public initializeNewForm() {
    this.fc.initializeNewForm();
  }

  submit(){   
    if(!this.onSubmitForm)  return;
    //Validate and get the subform values
    this.fc.Form.subForm.forEach((subforms, name) => {
      subforms.forEach(subform => {
        subform.pages.forEach(page => {
          page.submitted = true;
        });
      });
    });
    //Validate current form
    this.fc.Pages[this.fc.activeIndex].submitted = true;
    if(!this.fc.pagesFormGroup?.valid) return;

    const formValues = this.fc.Form.getFormValues();
    const dataString = JSON.stringify(formValues)    
    this.onSubmitForm(dataString);
  }
}
